var CountryCode;
(function (CountryCode) {
  CountryCode["AR"] = "AR";
  CountryCode["AU"] = "AU";
  CountryCode["AT"] = "AT";
  CountryCode["BE"] = "BE";
  CountryCode["BO"] = "BO";
  CountryCode["BR"] = "BR";
  CountryCode["BG"] = "BG";
  CountryCode["CA"] = "CA";
  CountryCode["CL"] = "CL";
  CountryCode["CO"] = "CO";
  CountryCode["CY"] = "CY";
  CountryCode["CZ"] = "CZ";
  CountryCode["CH"] = "CH";
  CountryCode["DK"] = "DK";
  CountryCode["DE"] = "DE";
  CountryCode["EC"] = "EC";
  CountryCode["EG"] = "EG";
  CountryCode["EE"] = "EE";
  CountryCode["ES"] = "ES";
  CountryCode["FI"] = "FI";
  CountryCode["FR"] = "FR";
  CountryCode["GR"] = "GR";
  CountryCode["GB"] = "GB";
  CountryCode["HK"] = "HK";
  CountryCode["ID"] = "ID";
  CountryCode["IE"] = "IE";
  CountryCode["IT"] = "IT";
  CountryCode["JP"] = "JP";
  CountryCode["LV"] = "LV";
  CountryCode["LT"] = "LT";
  CountryCode["LU"] = "LU";
  CountryCode["MT"] = "MT";
  CountryCode["MX"] = "MX";
  CountryCode["NL"] = "NL";
  CountryCode["NZ"] = "NZ";
  CountryCode["NO"] = "NO";
  CountryCode["PY"] = "PY";
  CountryCode["PL"] = "PL";
  CountryCode["PT"] = "PT";
  CountryCode["RO"] = "RO";
  CountryCode["SG"] = "SG";
  CountryCode["SK"] = "SK";
  CountryCode["SI"] = "SI";
  CountryCode["SE"] = "SE";
  CountryCode["TH"] = "TH";
  CountryCode["US"] = "US";
  CountryCode["ZA"] = "ZA";
})(CountryCode || (CountryCode = {}));

export { CountryCode };
